<template>
  <div class="sewageDeal" ref="sewageDeal">
    <div class="historyButton" @click="historicalTrendCheck">历史趋势 ☰</div>
    <div class="water_main">
      <ul class="sd_ul" v-if="dataArr.length">
        <li v-for="(item,i) in dataArr" :key="i">
          <div class="circle "></div>
          <div class="inner_box" v-if="item.value_name == 'PH值'">
            <div class="inner_box_num number absolute_center" :style="{color:item.value>9||item.value<6?'#FF7878':'#47FFDD'}">{{item.value}}</div>
            <div class="inner_box_standard absolute_center">限值{{item.standard_data}}</div>
          </div>
          <div class="inner_box" v-else>
            <div class="inner_box_num number absolute_center" :style="{color:item.value>=item.standard_data?'#FF7878':item.value>=0.8*item.standard_data?'#FFCB00':'#47FFDD'}">{{item.value}}</div>
            <div class="inner_box_standard absolute_center">限值{{item.standard_data + item.unit}}</div>
          </div>
        </li>
      </ul>
    </div>

    <div class="change_button"></div>
  </div>
</template>

<script>
import historicalTrend from "./components/historicalTrend";

import { mapState, mapGetters } from "vuex";
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      dataArr: [],
      timer: null,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.sewageDeal).outerWidth();
    let h = $(that.$refs.sewageDeal).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    async getListData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let getQgDevicesByType =
        CONFIG.requestName + this.$apiOpt.getQgDevicesByType;
      let res = await this.$apiUtils.get(getQgDevicesByType, {
        customerId: this.customerId,
        type: 2,
      });
      if (res && res["烧结厂"] && res["烧结厂"][0] && res["烧结厂"][0].list) {
        this.dataArr = res["烧结厂"][0].list;
      }
      this.timer = setTimeout(() => {
        this.getListData();
      }, 60 * 1000);
    },
    historicalTrendCheck() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(historicalTrend, this.dialogCompontent, this);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.sewageDeal {
  height: 250px;
  width: 910px;
  .historyButton {
    font-size: 18px;
    color: #f4c48f;
    text-align: end;
    cursor: pointer;
  }
  .water_main {
    margin-top: 10px;
    height: calc(100% - 30px);
    .sd_ul {
      display: flex;
      justify-content: space-between;
      li {
        position: relative;
        .circle {
          @include bg-box(125px, 125px, "circle.png");
          position: absolute;
          animation: rotate 20s linear infinite;
          top: 20px;
          left: 20px;
        }
        @keyframes rotate {
          0% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(-180deg);
          }
          100% {
            transform: rotate(-360deg);
          }
        }
        .inner_box {
          @include bg-box(164px, 168px, "squareBg.png");
          position: relative;
          .inner_box_num {
            font-size: 26px;
            color: #47ffdd;
            // line-height: 26px;
            top: 43%;
          }
          .inner_box_standard {
            font-size: 12px;
            top: 61%;
            color: #c8d8ff;
          }
        }
      }
    }
  }
  .change_button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 41px;
    height: 3px;
    background: #4be0ff;
    border-radius: 1px;
    cursor: pointer;
  }
}
.yellow_color {
  color: #ffcb00;
}
</style>

